module.exports = __webpack_public_path__ + "static/media/7_of_clubs.a02bac95.png";